export default __webpack_public_path__ + "static/media/update.3f1aa761.svg";